module.exports = __webpack_public_path__ + "static/media/r2d2.d3147a17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/r2d2.jpg
// module id = 34
// module chunks = 0